export const rolesConfig = {
	USER: 1,
	TEAM_MANAGER: 3,
	CLEANER: 6,
	GLOBAL_ADMIN: 101,
	BILLING_ADMIN: 102,
	SITE_ADMIN: 103,
	FLOOR_ADMIN: 104,
	TEAM_ADMIN: [105, 106], // 105: Team Admin, 106: Team Member (!deprecated, ask for this to be able o remove it)
	ASSETS_ADMIN: 107,
	GLOBAL_READ_ONLY: 108,
	SITE_READ_ONLY: 109,
	DEVELOPER: 201,
	ASSET_MANAGER: 202,
	INVENTORY_MANAGER: 203
};
